import { useEffect, useMemo, useState } from 'react'
import { addUpgradeReason } from '../../../../utils/general'
import { getTrackedLinksAnalytics } from '../../../../services/tracked-links'
import { setShowPaymentModal } from '../../../../actions'
import { PLANS } from '../../../../constants/plans'
import { useDispatch, useSelector } from 'react-redux'

export const useAnalyticsTracked = ({ domain }) => {
  const productId = useSelector((state) => state.manage.userProfile.productId) || null
  const hasAccess = useMemo(() => {
    return [PLANS.PRO.id, PLANS.PRO_U.id].includes(productId)
  }, [productId])

  const dispatch = useDispatch()
  const [trackedLinks, setTrackedLinks] = useState([])
  const [isLoadingLinks, setIsLoadingLinks] = useState(false)

  const getTrackedLinksList = async () => {
    setIsLoadingLinks(true)
    try {
      const data = await getTrackedLinksAnalytics(domain)
      setTrackedLinks(data)
    } catch (error) {
      setTrackedLinks([])
    } finally {
      setIsLoadingLinks(false)
    }
  }

  useEffect(() => {
    if (domain && hasAccess) {
      getTrackedLinksList()
    }
  }, [])

  const handleUpgrade = () => {
    addUpgradeReason('View Analytics')
    dispatch(setShowPaymentModal({ showPaymentModal: true, upgradePlanId: PLANS.PRO.id }))
  }

  const hasLinks = trackedLinks && trackedLinks.length > 0

  return {
    trackedLinks,
    isLoadingLinks,
    hasLinks,
    handleUpgrade
  }
}
